export default __webpack_public_path__ + "static/media/pic.0d84e235.png";